import React, { useEffect, useState } from 'react';
import DriscollsBanner from './DriscollsBanner';
import { connect } from 'react-redux';
import { withAuth } from '@okta/okta-react';
import { Middleware } from 'one-ring';
import { Divider } from '@material-ui/core';

const env = window.config.API_ENV;
const BANNER_API = `https://banner.${env}.ds-api.io/consumer?application=CEP`;
const language = 'en';


const Banner = ({ auth, isMasterDataInitialized }) => {
    const [banners, setBanners] = useState([]);

    const parseBanners = (data) => {
        const parsed =
            data &&
            data.map((item) => {
                const metadata = JSON.parse(item.metadata);
                return {
                    ...item,
                    content: metadata.content,
                    isDismissible: metadata.isDismissible,
                    color: metadata.color.toLowerCase(),
                };
            });
        return parsed || [];
    }


    const fetchBanners = (token) => {
        Middleware.Send(
            'banner',
            token,
            BANNER_API,
            'GET',
            {},
            { overrideRequestMapping: true },
        )
            .then((data) => {
                const parsedBanners = parseBanners(data.banners || []);
                setBanners(parsedBanners);
            })
            .catch((error) => {
                console.error('Error fetching banners:', error);
            });
    }

    useEffect(() => {
        if (!auth || !isMasterDataInitialized) return;

        auth.getAccessToken().then((token) => {
            fetchBanners(token);
        }).catch((error) => {
            console.error('Error getting access token:', error);
        });
    }, [auth, isMasterDataInitialized]);

    return banners && (
        <>
            {banners.map((banner, idx) => (
                <div>
                    <DriscollsBanner key={banner.id || idx} 
                        content={banner.content[language].text} 
                        isDismissible={banner.isDismissible} 
                        bgColor={banner.color} 
                        onClose={() => {
                            setBanners((prev) => prev.filter((_, i) => i !== idx));
                        }}
                    />
                    <Divider />
                </div>
            ))}
        </>
    );
};

function mapStateToProps(state) {
    return {
        isMasterDataInitialized: state.masterReducer.isInitialized
    };
}

export default withAuth(connect(mapStateToProps)(Banner));